//足球 杯赛 FIFAWC|世界杯 full
import PlatfromFootballFIFAWCFull from '@containers/platfrom_football/FIFAWorldCupFull_FIFAWC'

export default {
  PlatfromFootballFIFAWCFull,
}
